import { useEffect, useState } from 'react'
import { Text } from '@mantine/core'
import classes from './Time.module.css'

export default function Time() {
  const [time, setTime] = useState<string>(
    new Date().toLocaleTimeString('en-GB', { hour12: false })
  )

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date().toLocaleTimeString('en-GB', { hour12: false }))
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <Text component="p" className={classes.time}>
      {time}
    </Text>
  )
}
